module.exports = __webpack_public_path__ + "static/media/7ICJ2.7cfc1c21.jpg";